
function updateCurrency(newCurrency) {
  $.ajax({
    url: '/cart/update.js',
    dataType: 'JSON',
    type: 'POST',
    contentType: 'application/json',
    data: JSON.stringify({"currency": newCurrency}),
    success: function(){ 
      location.reload();
      Cookies.set('set_currency', 'true', { expires: 7 })
    },
    error: function(){
      alert('error!');
    }
  });
}

const countryToCurrency = {
  'CA': 'CAD',
  'US': 'USD'
}

let $mainFlag = $('.geo-redirect-popup__country-flag');

if(Cookies.get('set_currency') === undefined) {
  $.getJSON('https://get.geojs.io/v1/ip/country.json', function(data) {
    let countryCode = data.country;
    $mainFlag.attr('data-country-code', countryCode);
    $mainFlag.attr('src', `https://flagcdn.com/w160/${countryCode.toLowerCase()}.png`);
    addRedirectToFlags($mainFlag)
    $('.geo-redirect-popup').addClass('modal--is-active');
  });
}

// click event listener, so which grabs countrycode of flag and sends request to shopify to update currency
function addRedirectToFlags($mainFlag) {
  let mainFlagCountryCode = $mainFlag.data('country-code');

  $mainFlag.on('click', function() {
    let mainFlagCountryCurrency = countryToCurrency[mainFlagCountryCode]
    updateCurrency(mainFlagCountryCurrency)
  });
  
  $('.geo-redirect-popup__other-countries-wrapper .geo-redirect-popup__other-country-flag').each(function(i,flag) {
    let otherFlagCountryCode = $(flag).data('country-code');
    if(otherFlagCountryCode == mainFlagCountryCode) {
      flag.hide()
    } else {
     $(flag).on('click', function() {
       let otherFlagCountryCurrency = countryToCurrency[otherFlagCountryCode];
       updateCurrency(otherFlagCountryCurrency);
     });
    }
  });
}